module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-step-04-bc862d84f684f57a7b509576ef16c442.jpg";